// extracted by mini-css-extract-plugin
export default {"mapThumbnail":"MapThumbnail_mapThumbnail__kpyY7","mapThumbnailInner":"MapThumbnail_mapThumbnailInner__W8LAE"};